module.exports = __webpack_public_path__ + "static/media/First5_Post02-Image.5dc6ac90.jpg";